// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"891":"cdabbc027c8a5bac","5430":"86ba27ff0513a31c","6568":"c2e02cbcae6293ac"}[chunkId] + ".css";
};